let _mainNode
let _camVideo
let _mask
let _hiddenCanvas
let _settings

const camAlert = message => {
  console.error(message)
  document.dispatchEvent(new CustomEvent('apiError', {
    detail: { message: 'Произошла ошибка в работе камеры' }
  }))
}

import './style.css'
export default class CamService {
  constructor (mainNode, options) {
    console.log('constructoring "CamService"')
    console.log('[URV_PERF]', 'cam_service_constructor', {})
    _mainNode = mainNode
    const defaultOptions = {
      onCameraReady: null,
      onCameraFailed: null
    }
    _settings = Object.assign(defaultOptions, options)
  }

  initialize () {
    let getMedia
    try {
      console.log('defining "getMedia" object')
      console.log('[URV_PERF]', 'camera_init_start', {})
      getMedia = navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: 'user' } })
    } catch (e) {
      camAlert(`while defining "getMedia": ${e}`)
    }

    if (!getMedia) {
      camAlert('const getMedia is not defined at camService')
      if (_settings.onCameraFailed) _settings.onCameraFailed()
      return
    }

    try {
      console.log('initializing document')
      _mainNode.classList.add('webcam-service')
      const parentNodeHeight = _mainNode.parentNode.offsetHeight
      _mainNode.style.height = parentNodeHeight + 'px'

      const mainNodeWidth = _mainNode.offsetWidth
      const mainNodeHeight = _mainNode.offsetHeight

      _camVideo = document.createElement('video')
      _camVideo.setAttribute('autoplay', '')
      _camVideo.setAttribute('muted', '')
      _camVideo.setAttribute('playsinline', '')
      _camVideo.style.width = mainNodeWidth + 'px'
      _camVideo.style.height = mainNodeHeight + 'px'
      _camVideo.style.display = 'none'
      _mainNode.appendChild(_camVideo)

      _mask = document.createElement('div')
      _mask.classList.add('mask-overlay')
      _mainNode.appendChild(_mask)
      _hiddenCanvas = document.querySelector('.hidden-canvas')
      if (!_hiddenCanvas) {
        _hiddenCanvas = document.createElement('canvas')
        _hiddenCanvas.classList.add('hidden-canvas')
        document.body.appendChild(_hiddenCanvas)
      }
    } catch (e) {
      camAlert(`while initializing document: ${e}`)
    }

    console.log('initializing camera')
    getMedia
      .then((stream) => {
        console.log('[URV_PERF]', 'camera_init_done', {})
        if (_settings.onCameraReady) _settings.onCameraReady()
        _camVideo.srcObject = stream
        _camVideo.style.display = 'block'
        _camVideo.onloadedmetadata = function () {
          if (_camVideo.readyState >= 1) {
            _camVideo.play()
            reDrawMask()
          }
        }
        window.addEventListener('resize', reDrawMask, false)
      })
      .catch((err) => {
        if (_settings.onCameraFailed) _settings.onCameraFailed()
        camAlert(`Ошибка работы с камерой: ${err.name}: ${err}`)
      })

    function reDrawMask () {
      setTimeout(() => {
        try {
          const mainNodeWidth = _mainNode.offsetWidth
          const mainNodeHeight = _mainNode.offsetHeight
          const minValue = Math.min(mainNodeWidth, mainNodeHeight)
          const proportionPercent = 80
          const proportionValue = minValue / 100 * proportionPercent

          _mask.style.width = proportionValue + 'px'
          _mask.style.height = proportionValue + 'px'
          _mask.classList.add('fade-in')
        } catch (e) {
          camAlert(`error in "reDrawMask" function: ${e}`)
        }
      }, 200)
    }
  }

  pause () {
    try {
      _camVideo.pause()
    } catch (e) {
      camAlert(`pause failed: ${e}`)
    }
  }

  play () {
    try {
      _camVideo.play()
    } catch (e) {
      camAlert(`play failed: ${e}`)
    }
  }

  hideMask () {
    _mask.style.display = 'none'
  }

  showMask () {
    _mask.style.display = 'block'
  }

  getPicture () {
    return new Promise((resolve) => {
      try {
        const ctx = _hiddenCanvas.getContext('2d')
        const w = _camVideo.videoWidth
        const h = _camVideo.videoHeight
        _hiddenCanvas.width = w
        _hiddenCanvas.height = h

        ctx.drawImage(_camVideo, 0, 0, w, h)
        ctx.font = '16px Arial'
        ctx.fillText((new Date()).toString(), 0, 20)

        _hiddenCanvas.toBlob((blob) => {
          resolve(blob)
        }, 'image/jpeg')
      } catch (e) {
        camAlert(`error in "getPicture" function: ${e}`)
      }
    })
  }
  /*
  getPicture () {
    return new Promise((resolve) => {
      const img = new Image()
      img.onload = function () {
        const ctx = _hiddenCanvas.getContext('2d')
        const w = img.width
        const h = img.height
        _hiddenCanvas.width = w
        _hiddenCanvas.height = h

        ctx.drawImage(img, 0, 0, w, h)
        _hiddenCanvas.toBlob((blob) => {
          console.log(blob)
          resolve(blob)
        }, 'image/jpeg')
      }
      img.src = '../../assets/img/obamah.jpg'
    })
  }
  */
}
